export class CroppedImage{
    public imagePath: any;
    public imageFile: File;
}